import React from "react";
import TabOutlinedIcon from "@mui/icons-material/TabOutlined";
import { uploadTrustCenterFavicon } from "../../../../apis/trust-center-apis/trustCenterApis";
import {
  FAVICON_ACCEPT_ATTRIBUTE,
  FAVICON_HINT,
  validateFavicon,
} from "../../data/uploadRules";
import BrandImageField from "./BrandImageField";

// The icon in the browser tab on the public page (and custom domain).
const FaviconField = ({ faviconPath, onChange }) => (
  <BrandImageField
    name="Favicon"
    path={faviconPath}
    pathKey="faviconPath"
    upload={uploadTrustCenterFavicon}
    validate={validateFavicon}
    hint={`${FAVICON_HINT}. Shown in the browser tab once you save and publish.`}
    icon={TabOutlinedIcon}
    previewSize={{ width: 48, height: 48 }}
    accept={FAVICON_ACCEPT_ATTRIBUTE}
    onChange={onChange}
  />
);

export default FaviconField;
